import React, { useEffect, useState } from "react";
import { fetchTransactions } from "../api.js";

export default function MonthlyViewPage() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    fetchTransactions().then(setItems);
  }, []);

  const grouped = items.reduce((acc, t) => {
    const key = t.monthKey;
    if (!acc[key]) acc[key] = [];
    acc[key].push(t);
    return acc;
  }, {});

  const months = Object.keys(grouped).sort();

  return (
    <div>
      <h2>Monthly View</h2>

      {months.map((month) => {
        const list = grouped[month];

        const totalIn = list
          .filter((t) => t.type === "in")
          .reduce((sum, t) => sum + t.amount, 0);

        const totalOut = list
          .filter((t) => t.type === "out")
          .reduce((sum, t) => sum + t.amount, 0);

        return (
          <div key={month}>
            <h3>Month: {month}</h3>
            <p>Total In: {totalIn}</p>
            <p>Total Out: {totalOut}</p>

            {list.map((t) => (
              <div key={t._id}>
                <span>{new Date(t.date).toLocaleDateString()} – </span>
                <span>{t.name} – </span>
                <span>{t.type} – </span>
                <span>{t.amount}</span>
              </div>
            ))}

            <hr />
          </div>
        );
      })}
    </div>
  );
}
